<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-card-section"
    full-width
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-grid
      v-if="items && items.length"
      :columns="1"
      :m-columns="2"
      :l-columns="3"
    >
      <zg-card
        v-for="(card, index) in items"
        :key="card.contentId || index"
        :title="card.title"
        :text="card.text"
        :link="card.link"
        :image="card.image"
        :background="cardBackground"
      >
        <slot
          slot="text-content"
          :name="`text-content-${index}`"
        />
      </zg-card>
    </zg-grid>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgGrid from '../../layout/grid/ZgGrid.vue'
  import ZgCard from '../../ZgCard/ZgCard.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgCardSection',
    components: {
      ZgModule,
      ZgGrid,
      ZgCard
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true
      }
    }
  }
</script>
